import lcid from "./utils/lookup.js";
import iso from "./utils/iso-codes.js";

interface LocaleEntry {
  name: string;
  location: string;
  tag: string;
  lcid: number;
  "iso639-2": string;
  "iso639-1": string | null;
}

const locales: LocaleEntry[] = [];
const isoKeys: string[] = Object.keys(iso);

Object.keys(lcid).map((id: string) => {
  const locale = lcid[id];
  const isoLanguage = isoKeys.find(
    name => name.toLowerCase() === locale.language.toLowerCase(),
  );
  if (locale.location && isoLanguage) {
    locales.push({
      ["name"]: locale.language,
      ["location"]: locale.location,
      ["tag"]: locale.tag,
      ["lcid"]: locale.id,
      ["iso639-2"]: iso[isoLanguage]["iso639-2"],
      ["iso639-1"]: iso[isoLanguage]["iso639-1"],
    });
  }
});

const defaultLocales: Record<string, string> = {
  ar: "ar-SA",
  ca: "ca-ES",
  da: "da-DK",
  en: "en-US",
  ko: "ko-KR",
  pa: "pa-IN",
  pt: "pt-BR",
  sv: "sv-SE",
  zh: "zh-CN",
};

/**
    Converts a 2-letter language code into a full language-region locale string (e.g., "en" to "en-US").
    @param locale A 2-letter language code (e.g., "en", "fr").
*/
export default function findLocale(locale: string): string {
  if (typeof locale !== "string" || locale.length === 5) return locale;
  if (defaultLocales[locale]) return defaultLocales[locale];
  const list = locales.filter(d => d["iso639-1"] === locale);
  if (!list.length) return locale;
  else if (list.length === 1) return list[0].tag;
  else if (list.find(d => d.tag === `${locale}-${locale.toUpperCase()}`))
    return `${locale}-${locale.toUpperCase()}`;
  else return list[0].tag;
}
